<template>
  <el-dialog class="repeat-login-dialog"
             :visible.sync="repeatLogin.flag"
             title
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="460px"
             center>
    <div class="wrap">
      <img :src="warning" alt="">
      <p v-html="repeatLogin.msg"></p>
      <el-button type="primary" @click="goLogin">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { mapMutations } from "vuex";
  import warning from "@/assets/images/warning.png";
  export default {
    name: "Warn",
    data() {
      return {
        warning,
      };
    },
    computed: {
      /*showFooter() {
        return this.$store.state.showFooter;
      }*/
      repeatLogin: {
        get() {
          return this.$store.state.repeatLogin;
        },
        set(bool) {
          this.setRepeatLogin({
            flag: bool,
            msg: ""
          });
        }
      },
    },
    methods: {
      ...mapMutations(["setRepeatLogin"]),
      goLogin() {
        this.repeatLogin = false;
        this.$router.replace("/login");
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .repeat-login-dialog {
    .wrap {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        width: 100%;
        margin: 20px 0 30px;
        text-align: center;
        font-size: $font_size_big;
        word-break: break-all;
      }
    }
  }
</style>